import {
    InvokeCommand,
    LambdaClient,
} from '@aws-sdk/client-lambda'
import {
    fetchAuthSession,
} from 'aws-amplify/auth'

import {
    RestAPI,
} from 'konekti-ex-functions'

import { Buffer } from 'buffer'

// DataStreamAPI呼び出し用クラス
// 定義用抽象クラス
export abstract class iDDSAPI {
    abstract call(name: string, payload: Object): Promise<any>;
}

// クラウド版 AWS Lambda SDK
export class DDSAPILambda extends iDDSAPI {
    private outputs = window.AmplifyOutputs;
    async call(name: string, payload: Object): Promise<any> {
        const { credentials } = await fetchAuthSession()
        const awsRegion = this.outputs.auth.aws_region

        try {
            const lambda = new LambdaClient({ credentials: credentials, region: awsRegion })
            const command = new InvokeCommand({
                FunctionName: name,
                Payload: Buffer.from(JSON.stringify(payload), "utf8"),
                InvocationType: 'RequestResponse',
            });
            const apiResponse = await lambda.send(command);

            const result = JSON.parse(new TextDecoder().decode(apiResponse.Payload))
            // Lambda関数内のSDK呼び出しがエラーになった場合
            // レスポンスは 200 OK の正常状態で返却され
            // FunctionErrorが設定され、PayloadのerrorMessageにエラーメッセージが格納されている
            if (apiResponse.FunctionError) {
                throw new Error(result.errorMessage)
            }
            return result as unknown
        } catch (e) {
            throw e
        }
    }
}

// オンプレ版 NodeRED API呼び出し
export class DDSAPINodeRED extends iDDSAPI {
    async call(name: string, payload: Object): Promise<any> {
        try {
            const apiResponse = await RestAPI.set(`/${name}`, payload)
            if (!apiResponse.ok) {
                throw new Error(apiResponse.message)
            }
            const result = apiResponse.json
            return result as unknown
        } catch (e) {
            throw e
        }
    }
}

export const DDSAPI = window.AmplifyOutputs.env.onpre ? new DDSAPINodeRED() : new DDSAPILambda();
